import { render, staticRenderFns } from "./ProdutosServicosFormModal.vue?vue&type=template&id=71b60a05&scoped=true"
import script from "./ProdutosServicosFormModal.vue?vue&type=script&lang=js"
export * from "./ProdutosServicosFormModal.vue?vue&type=script&lang=js"
import style0 from "./ProdutosServicosFormModal.vue?vue&type=style&index=0&id=71b60a05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b60a05",
  null
  
)

export default component.exports